import { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Popover, ArrowContainer } from 'react-tiny-popover'

import { Box, Icon, theme } from '@redriverpress/system'

const StyledHint = styled(Icon).attrs(() => ({
  color: 'black',
  p: 1,
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`

function Hint({ text }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      isOpen={isOpen}
      onClickOutside={() => setIsOpen(false)}
      positions={['top', 'bottom']}
      align='end'
      containerStyle={{ overflow: 'visible', zIndex: 3 }}
      padding={2}
      content={({ position, popoverRect, childRect }) => (
        <ArrowContainer
          position={position}
          popoverRect={popoverRect}
          childRect={childRect}
          arrowSize={8}
          arrowColor={theme.colors.gray900}
          style={{
            filter: theme.dropShadows[2],
            maxWidth: '240px',
          }}
        >
          <Box
            bg='gray900'
            color='white'
            px='10px'
            py='14px'
            borderRadius='rounded'
            fontSize='0.723rem'
            fontWeight={600}
            letterSpacing='condensed'
            textAlign='center'
          >
            {text}
          </Box>
        </ArrowContainer>
      )}
    >
      <StyledHint
        icon='question-circle'
        title={text}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onTouchStart={() => setIsOpen(true)}
        onTouchEnd={() => setIsOpen(false)}
        onTouchCancel={() => setIsOpen(false)}
      />
    </Popover>
  )
}

Hint.propTypes = {
  text: PropTypes.string.isRequired,
}

export default Hint
